<div class="modal-header">
  <h5 class="modal-title">{{ 'BULK_ADD_SCHOOL_PROGRAM' | translate }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>

<div class="modal-body">
  <p class="grid-hint">
    Edit existing rows or use Add row to create new programs. Pick a
    location, enter the name and description, then Save.
  </p>

  <div *ngIf="!loading" class="grid-actions">
    <button type="button" class="action-btn action-btn-edit" (click)="onAddRow()">
      + Add row
    </button>
    <span class="revo-grid-legend">
      <span class="revo-grid-legend-swatch"></span>
      {{ 'GRID_REQUIRED_LEGEND' | translate }}
    </span>
  </div>

  <div *ngIf="loading" class="grid-loading">Loading…</div>

  <revo-grid
    *ngIf="!loading"
    #programGrid
    class="program-grid"
    theme="material"
    [columns]="columns"
    [columnTypes]="columnTypes"
    [source]="source"
    [rowSize]="32"
    [applyOnClose]="true"
    [resize]="true"
    [range]="true"
    [canFocus]="true"
    [useClipboard]="clipboardConfig"
    [rowHeaders]="true"
    [stretch]="true"
    [hideAttribution]="true"
    [plugins]="gridPlugins"
    (newRows)="onNewRows($event)"
    (beforekeydown)="onGridKeydown($event)"
    (afteredit)="onAfterEdit($event)">
  </revo-grid>
</div>

<div class="modal-footer">
  <button type="button" class="action-btn" (click)="onClose()" [disabled]="saving">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    type="button"
    class="action-btn action-btn-create"
    (click)="onSave()"
    [disabled]="saving || loading">
    {{ (saving ? 'SAVING' : 'SAVE') | translate }}
  </button>
</div>
